"use client";

import { useState } from "react";
import "./CommonCTASection.scss";

import Button from "@/components/Button/Button";
import ContactFormModal from "@/components/ContactFormModal/ContactFormModal";

const CommonCTASection = ({
  title,
  description,
  buttonText = "Get Started",
  sectionClass = "",
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setShowModal(true);
  };

  const renderTitle = (text) => {
    if (!text) return null;

    const parts = text.split(/"([^"]+)"/g);

    return parts.map((part, index) =>
      index % 2 === 1 ? (
        <span key={index} className="highlight">
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  return (
    <section
      className={`reusable-cta-section ${sectionClass}`}
      data-aos="zoom-in"
    >
      <div className="blur-bg" />

      <div className="cta-container">
        <h2>{renderTitle(title)}</h2>

        {description && <p>{description}</p>}

        <Button
          variant="primary"
          size="lg"
          className="cta-btn"
          onClick={handleClick}
        >
          {buttonText}
        </Button>
      </div>

      <ContactFormModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={() => setShowModal(false)}
      />

      <span className="shape shape1" />
      <span className="shape shape2" />
      <span className="shape shape3" />
      <span className="shape shape4" />
    </section>
  );
};

export default CommonCTASection;
